import { render } from "./bigCommerce.vue?vue&type=template&id=7add9f56&scoped=true"
import script from "./bigCommerce.vue?vue&type=script&lang=js"
export * from "./bigCommerce.vue?vue&type=script&lang=js"

import "./bigCommerce.vue?vue&type=style&index=0&id=7add9f56&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7add9f56"]])

export default __exports__